import * as Utils from './savanna_utils.js';

/* PERFORMANCE MANAGEMENT OBJ PLANS RULES */
export async function get_current_step_rules(performance_cycle_id, current_step, employee_id)
{
	let current_employee = Utils.current_employee_id();
	let user_role = '';

	// Determine if the current user is the employee or a manager
	if (current_employee === employee_id)
		user_role = 'employee';

	let manager_result = await Grape.fetches.getJSON('/api/record', {
		table: 'manager_employee',
		schema: 'public',
		filter: [{
			field: 'subordinate_employee_id',
			operand: '=',
			value: employee_id
		}]
	});

	if (manager_result.status != 'ERROR' && manager_result.records.some(record => record.employee_id === current_employee))
		user_role = 'manager';

	if (current_step)
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_cycle_stages',
			schema: 'perfm_manage',
			filter_join: 'AND',
			filter: [{
				field: 'performance_cycle_id',
				operand: '=',
				value: performance_cycle_id
			},
			{
				field: 'step_sequence',
				operand: '=',
				value: current_step
			}]
		});
		

		if (res.status != 'ERROR' && res.result_count != 0)
		{
			let step = res.records[0];
			let current_rules = step.rules;

			// Start with all rules set to false by default
			let rules = {
				all_fields_everyone: false,
				all_fields_employee: false,
				all_fields_locked: false,
				name_description: false,
				outcomes_measures: false,
				feedback_manager: false,
				feedback_employee: false,
				peer_feedback: false,
				setup_peer_reviewer: false,
				add_objectives: false,
				edit_performance_cycle: false,
				linked_company_objectives: false
			};

			// Enable edit_performance_cycle based on step
			if (current_step <= 1)
				rules.edit_performance_cycle = true;

			// Process each rule by explicitly setting fields to true
			current_rules.forEach(rule_obj => {
				let rule = rule_obj.rule;
				switch (rule)
				{
					case 'All fields editable by: Employee & Manager(s)':
						rules.all_fields_everyone = true;
						rules.all_fields_locked = false;
						rules.name_description = true;
						rules.outcomes_measures = true;
						rules.feedback_manager = true;
						rules.feedback_employee = true;
						rules.peer_feedback = true;
						rules.setup_peer_reviewer = true;
						rules.add_objectives = true;
						break;
					case 'Objective fields locked':
						rules.name_description = false;
						rules.outcomes_measures = false;
						break;
					case 'Cannot add new/remove objectives':
						rules.add_objectives = false;
						break;
					case 'Objective fields locked (name & description)':
						rules.name_description = false;
						break;
					case 'Objective fields locked (outcomes & measures)':
						rules.outcomes_measures = false;
						break;
					case 'Feedback fields editable by: All':
						rules.feedback_manager = true;
						rules.feedback_employee = true;
						rules.peer_feedback = true;
						break;
					case 'Feedback fields editable by: Manager':
						rules.feedback_manager = true;
						break;
					case 'Feedback fields editable by: Employee':
						rules.feedback_employee = true;
						break;
					case 'Peer reviewer feedback fields editable':
						rules.peer_feedback = true;
						break;
					case 'Setup peer reviewer locked':
						rules.setup_peer_reviewer = false;
						break;
					case 'All data locked for employee':
						rules.all_fields_employee = true;
						break;
					case 'All data locked':
						rules.all_fields_locked = true;
						rules.all_fields_everyone = false;
						rules.all_fields_employee = false;
						rules.name_description = false;
						rules.outcomes_measures = false;
						rules.feedback_manager = false;
						rules.feedback_employee = false;
						rules.peer_feedback = false;
						rules.setup_peer_reviewer = false;
						rules.add_objectives = false;
						rules.edit_performance_cycle = false;
						break;
					default:
						console.warn('Unknown rule:', rule);
				}
			});

			// Special case - enable specific fields based on rules
			if (!rules.all_fields_locked) {
				// If not explicitly set elsewhere, these fields default to true
				if (!current_rules.some(r => r.rule.includes('name & description') || r.rule === 'Objective fields locked')) {
					rules.name_description = true;
				}
				if (!current_rules.some(r => r.rule.includes('outcomes & measures') || r.rule === 'Objective fields locked')) {
					rules.outcomes_measures = true;
				}
				if (!current_rules.some(r => r.rule === 'Cannot add new/remove objectives')) {
					rules.add_objectives = true;
				}
				if (!current_rules.some(r => r.rule === 'Setup peer reviewer locked')) {
					rules.setup_peer_reviewer = true;
				}
			}

			// Adjust rules based on user role
			if (user_role === 'employee')
			{
				// Employees can't edit manager feedback
				rules.feedback_manager = false;
				rules.peer_feedback = false;

				// If employee fields are locked, set all fields to locked for the employee
				if (!rules.all_fields_employee) {
					rules.all_fields_locked = true;
				}
			}
			else if (user_role === 'manager')
			{
				// Managers can't edit employee feedback
				rules.feedback_employee = false;
				rules.peer_feedback = false;
			}

			return rules;
		}
		else {
			console.error('Error fetching records or no records found');
			return null;
		}
	}
	else
	{
		// Default rules when no current step
		let rules = {
			all_fields_everyone: false,
			all_fields_employee: false,
			all_fields_locked: false,
			name_description: true,
			outcomes_measures: true,
			feedback_manager: true,
			feedback_employee: true,
			peer_feedback: true,
			setup_peer_reviewer: true,
			add_objectives: false, // Changed from true to false in default state
			edit_performance_cycle: true,
			linked_company_objectives: true
		};
		return rules;
	}
}

export async function get_steps_progress(performance_cycle_id, current_step, status)
{
	let all_steps;
	let res_steps = await Grape.fetches.getJSON('/api/record', {
		table: 'v_cycle_stages',
		schema: 'perfm_manage',
		filter_join: 'AND',
		filter: [{
			field: 'performance_cycle_id',
			operand: '=',
			value: performance_cycle_id
		}]
	});

	if (res_steps.status !== 'ERROR')
	{
		all_steps = res_steps.records;

		all_steps = all_steps.map(step => {
			if (step.step_sequence < current_step)
				return { ...step, status: 'Completed' };
			else if (step.step_sequence == current_step)
				return { ...step, status: status };
			else
				return { ...step, status: 'Not Started' };
		});

		all_steps.sort((a, b) => a.step_sequence - b.step_sequence);
	}
	else
		all_steps = [];

	return all_steps;
}